import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

interface FindProps {
  jurySessionId: number;
  studentIds: number[];
}

const { useFind: useJurySessionEligibleStudents } = getCRUDHooks({
  entityName: 'jurySessionEligibleStudent',
  find: ({ jurySessionId, studentIds }: FindProps) =>
    clientApi
      .getOCClient()
      .helpers.learningActivity.jurySessions.id(jurySessionId)
      .eligibleStudents.find({ studentIds: studentIds.join(',') }),
});

// eslint-disable-next-line import/prefer-default-export
export { useJurySessionEligibleStudents };
